import InputMask from 'inputmask/dist/inputmask/inputmask.numeric.extensions'

export default class CurrencyFormatter {
  constructor () {
    document.addEventListener('react-components-load', this.formatCurrencies)
  }

  formatCurrencies () {
    let elements = $('.format-currency')
    InputMask('decimal', {
      'groupSeparator': ' ',
      'autoGroup': true,
      'rightAlign': false,
      'autoUnmask': true,
      'removeMaskOnSubmit': true
    }).mask(elements)
  }
}
